import React from 'react';
import Dsy from './dsyui';
import { createComponent } from '@lit-labs/react';

const LitComp = Dsy.components.DsyForm;

export const DsyForm = createComponent(
    React,
    "dsy-form",
    LitComp,
    {}
)